// extracted by mini-css-extract-plugin
var _1 = "ProfileDateWithUserWidgetItem-moduleProfileDateWithUserWidgetItem__oukNF";
var _2 = "ProfileDateWithUserWidgetItem-moduledate__HvV2J";
var _3 = "ProfileDateWithUserWidgetItem-modulelabel__RMi2x";
var _4 = "ProfileDateWithUserWidgetItem-moduleuserLabel__JfF9V";
export { _1 as "ProfileDateWithUserWidgetItem", _2 as "date", _3 as "label", _4 as "userLabel" }
